// extracted by mini-css-extract-plugin
export default {"image":"PkPiNQPMBkD3mmG-yzhIH display-block centered width-60"};